import { useEffect } from "react";

export function useSeo({ title, description, schema }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    const path = window.location.pathname === "/" ? "/" : window.location.pathname;
    const url = `https://truverseuae.com${path === "/" ? "/" : path}`;
    setMeta("property", "og:url", url);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    let script = document.getElementById("page-jsonld");
    if (schema) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(schema);
    } else if (script) {
      script.remove();
    }
  }, [title, description, schema]);
}

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  name: "TruVerse Middle East",
  description:
    "International tax, transfer pricing, India capability centres and family office advisory for the UAE and India.",
  email: "pro@truverse.in",
  telephone: "+91 72002 40550",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Willingdon Crescent, 4th Floor, #6/2, Dr. S.S. Badrinath Road, Nungambakkam",
    addressLocality: "Chennai",
    postalCode: "600 006",
    addressCountry: "IN",
  },
  parentOrganization: { "@type": "Organization", name: "TruVerse", url: "https://truverse.in" },
};

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: (faqs || []).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function articleSchema(post) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.excerpt,
    author: { "@type": "Organization", name: post.author || "TruVerse Middle East" },
    datePublished: post.created_at,
  };
}
